// // // import React, { useState, useEffect } from 'react';
// // // import './FileUpload.css';
// // // import { useSelector } from 'react-redux';
// // // import { useNavigate } from 'react-router-dom';
// // // import axios from 'axios';
// // // import Select from 'react-select';

// // // function FileUpload() {
// // //   const backendURL = process.env.REACT_APP_backend_url;
// // //   const navigate = useNavigate();
// // //   const user = useSelector((state) => state.User.currentUser);

// // //   const [title, setTitle] = useState('');
// // //   const [abstract, setAbstract] = useState('');
// // //   const [requirements, setRequirements] = useState('');
// // //   const [domain, setDomain] = useState('');
// // //   const [department, setDepartment] = useState('');
// // //   const [selectedDomain, setSelectedDomain] = useState(null);
// // //   const [showWarning, setShowWarning] = useState(false);
// // //   const [similarProject, setSimilarProject] = useState(null);
// // //   const [errorMessage, setErrorMessage] = useState('');

// // //   const projectDomains = [
// // //     { value: 'Artificial Intelligence', label: 'Artificial Intelligence' },
// // //     { value: 'Machine Learning', label: 'Machine Learning' },
// // //     { value: 'Data Science', label: 'Data Science' },
// // //     { value: 'Cybersecurity', label: 'Cybersecurity' },
// // //     { value: 'Cloud Computing', label: 'Cloud Computing' },
// // //     { value: 'Blockchain', label: 'Blockchain' },
// // //     { value: 'IoT (Internet of Things)', label: 'IoT (Internet of Things)' },
// // //     { value: 'Robotics', label: 'Robotics' },
// // //     { value: 'Embedded Systems', label: 'Embedded Systems' },
// // //     { value: 'VLSI', label: 'VLSI' },
// // //     { value: 'Renewable Energy', label: 'Renewable Energy' },
// // //     { value: 'Big Data', label: 'Big Data' },
// // //     { value: 'Quantum Computing', label: 'Quantum Computing' },
// // //     { value: 'Natural Language Processing', label: 'Natural Language Processing' },
// // //     { value: 'Computer Vision', label: 'Computer Vision' },
// // //     { value: 'Augmented Reality (AR)', label: 'Augmented Reality (AR)' },
// // //     { value: 'Virtual Reality (VR)', label: 'Virtual Reality (VR)' },
// // //     { value: 'Wireless Networks', label: 'Wireless Networks' },
// // //     { value: 'Software Engineering', label: 'Software Engineering' },
// // //     { value: 'Biotechnology', label: 'Biotechnology' },
// // //   ];

// // //   const handleDomainChange = (selectedOption) => {
// // //     setSelectedDomain(selectedOption);
// // //     setDomain(selectedOption.value);
// // //   };

// // //   const handleSearchChange = (event) => {
// // //     setTitle(event.target.value);
// // //   };

// // //   const handleSearchSubmit = async (event) => {
// // //     event.preventDefault();
// // //     if (!title || !abstract || !requirements || !domain || !department) {
// // //       setErrorMessage('Please fill out all the fields.');
// // //       return;
// // //     }

// // //     try {
// // //       const token = sessionStorage.getItem('Token');
// // //       const response = await axios.post(`${backendURL}/searchForProject`, {
// // //         query: title,
// // //       }, {
// // //         headers: { Authorization: `Bearer ${token}` },
// // //       });

// // //       const results = response.data;

// // //       if (results.length > 0) {
// // //         const top = results[0];
// // //         setSimilarProject({
// // //           title: top.project.title,
// // //           abstract: top.project.abstract || 'No abstract available.',
// // //           similarity: (top.score * 100).toFixed(2),
// // //           isHighSimilarity: top.score > 0.8,
// // //         });
// // //         setShowWarning(true);
// // //       } else {
// // //         submitForm(token);
// // //       }
// // //     } catch (error) {
// // //       setErrorMessage('An error occurred while checking similar projects.');
// // //       console.error('Search error:', error);
// // //     }
// // //   };

// // //   const submitForm = async (token) => {
// // //     const data = {
// // //       title,
// // //       abstract,
// // //       requirements,
// // //       staffname: user.name,
// // //       domain,
// // //       department,
// // //       roll_id: user.rollId,
// // //     };

// // //     try {
// // //       const response = await axios.post(`${backendURL}/add_project`, data, {
// // //         headers: {
// // //           'Content-Type': 'application/json',
// // //           'Authorization': `Bearer ${token}`,
// // //         },
// // //         withCredentials: true,
// // //       });

// // //       if (response.data.message === 'Project added successfully!') {
// // //         navigate('/EditDeletePublish');
// // //       }
// // //     } catch (error) {
// // //       setErrorMessage('An error occurred while submitting the project. Please try again.');
// // //       console.error('Form submission error:', error);
// // //     }
// // //   };

// // //   const customStyles = {
// // //     container: (provided) => ({ ...provided, width: '100%' }),
// // //     control: (provided) => ({
// // //       ...provided,
// // //       backgroundColor: '#f0f0f0',
// // //       border: '1px solid #ccc',
// // //       borderRadius: '5px',
// // //       boxShadow: 'none',
// // //     }),
// // //     menu: (provided) => ({ ...provided, borderRadius: '5px' }),
// // //     option: (provided, state) => ({
// // //       ...provided,
// // //       backgroundColor: state.isFocused ? '#dcdcdc' : 'white',
// // //       color: 'black',
// // //     }),
// // //     singleValue: (provided) => ({ ...provided, color: 'black' }),
// // //   };

// // //   useEffect(() => {
// // //     if (!user) {
// // //       navigate('/login');
// // //     }
// // //   }, [user, navigate]);

// // //   return (
// // //     <div className="upload-container-custom">
// // //       <h2>Submit Your Data</h2>
// // //       <form className="upload-form-horizontal" onSubmit={handleSearchSubmit}>
// // //         <div className="form-item">
// // //           <label htmlFor="title">Title</label>
// // //           <input
// // //             id="title"
// // //             type="text"
// // //             value={title}
// // //             onChange={handleSearchChange}
// // //             required
// // //             aria-label="Enter the project title"
// // //           />
// // //         </div>

// // //         <div className="form-item">
// // //           <label htmlFor="abstract">Abstract</label>
// // //           <textarea
// // //             id="abstract"
// // //             value={abstract}
// // //             onChange={(e) => setAbstract(e.target.value)}
// // //             required
// // //           />
// // //         </div>

// // //         <div className="form-item">
// // //           <label htmlFor="requirements">Requirements</label>
// // //           <textarea
// // //             id="requirements"
// // //             value={requirements}
// // //             onChange={(e) => setRequirements(e.target.value)}
// // //             required
// // //           />
// // //         </div>

// // //         <div className="form-item">
// // //           <label>Faculty</label>
// // //           <input type="text" value={user.name} disabled />
// // //         </div>

// // //         <div className="form-item">
// // //           <label htmlFor="domain">Domain</label>
// // //           <Select
// // //             id="domain"
// // //             options={projectDomains}
// // //             styles={customStyles}
// // //             value={selectedDomain}
// // //             onChange={handleDomainChange}
// // //             isSearchable
// // //             placeholder="Search and select a domain..."
// // //           />
// // //         </div>

// // //         <div className="form-item">
// // //           <label htmlFor="department">Department</label>
// // //           <select
// // //             id="department"
// // //             value={department}
// // //             onChange={(e) => setDepartment(e.target.value)}
// // //             required
// // //           >
// // //             <option value="">Select Department</option>
// // //             <option value="CE">CE</option>
// // //             <option value="EEE">EEE</option>
// // //             <option value="ECE">ECE</option>
// // //             <option value="ME">ME</option>
// // //             <option value="CSE">CSE</option>
// // //             <option value="CS-AIML">CS-AIML</option>
// // //             <option value="CS-DS">CS-DS</option>
// // //             <option value="CS-IOT">CS-IOT</option>
// // //             <option value="CS-CyS">CS-CyS</option>
// // //             <option value="AI & DS">AI & DS</option>
// // //             <option value="CSBS">CSBS</option>
// // //             <option value="EIE">EIE</option>
// // //             <option value="IT">IT</option>
// // //             <option value="AE">AE</option>
// // //           </select>
// // //         </div>

// // //         <button type="submit" className="submit-btn">Submit</button>
// // //       </form>

// // //       {errorMessage && <div className="error-message">{errorMessage}</div>}

// // //       {showWarning && similarProject && (
// // //         <div
// // //           className="warning-popup"
// // //           style={{
// // //             backgroundColor: similarProject.isHighSimilarity ? '#ffe5e5' : '#f0f0f0',
// // //             border: `2px solid ${similarProject.isHighSimilarity ? 'red' : '#999'}`,
// // //             padding: '15px',
// // //             marginTop: '20px',
// // //             borderRadius: '10px',
// // //           }}
// // //         >
// // //           <h3 style={{ color: similarProject.isHighSimilarity ? 'red' : '#333' }}>
// // //             {similarProject.isHighSimilarity
// // //               ? '⚠️ High Similarity Project Found'
// // //               : 'ℹ️ Similar Project Found'}
// // //           </h3>
// // //           <p><strong>Title:</strong> {similarProject.title}</p>
// // //           <p><strong>Similarity:</strong> {similarProject.similarity}%</p>
// // //           <p><strong>Abstract:</strong> {similarProject.abstract}</p>
// // //           <p>Do you want to edit or continue submission?</p>
// // //           <button
// // //             className="submit-btn"
// // //             onClick={() => {
// // //               const token = sessionStorage.getItem('Token');
// // //               submitForm(token);
// // //               setShowWarning(false);
// // //             }}
// // //           >
// // //             ✅ Submit Anyway
// // //           </button>
// // //           <button
// // //             className="cancel-btn"
// // //             onClick={() => setShowWarning(false)}
// // //             style={{ marginLeft: '10px' }}
// // //           >
// // //             ✏️ Edit Project
// // //           </button>
// // //         </div>
// // //       )}
// // //     </div>
// // //   );
// // // }

// // // export default FileUpload;
// // import React, { useState, useEffect } from 'react';
// // import './FileUpload1.css';
// // import { useSelector } from 'react-redux';
// // import { useNavigate } from 'react-router-dom';
// // import axios from 'axios';
// // import Select from 'react-select';

// // function FileUpload() {
// //   const backendURL = process.env.REACT_APP_backend_url;
// //   const navigate = useNavigate();
// //   const user = useSelector((state) => state.User.currentUser);

// //   const [title, setTitle] = useState('');
// //   const [abstract, setAbstract] = useState('');
// //   const [requirements, setRequirements] = useState('');
// //   const [domain, setDomain] = useState('');
// //   const [department, setDepartment] = useState('');
// //   const [selectedDomain, setSelectedDomain] = useState(null);
// //   const [showWarning, setShowWarning] = useState(false);
// //   const [similarProject, setSimilarProject] = useState(null);
// //   const [errorMessage, setErrorMessage] = useState('');

// //   const projectDomains = [
// //     { value: 'Artificial Intelligence', label: 'Artificial Intelligence' },
// //     { value: 'Machine Learning', label: 'Machine Learning' },
// //     { value: 'Data Science', label: 'Data Science' },
// //     { value: 'Cybersecurity', label: 'Cybersecurity' },
// //     { value: 'Cloud Computing', label: 'Cloud Computing' },
// //     { value: 'Blockchain', label: 'Blockchain' },
// //     { value: 'IoT (Internet of Things)', label: 'IoT (Internet of Things)' },
// //     { value: 'Robotics', label: 'Robotics' },
// //     { value: 'Embedded Systems', label: 'Embedded Systems' },
// //     { value: 'VLSI', label: 'VLSI' },
// //     { value: 'Renewable Energy', label: 'Renewable Energy' },
// //     { value: 'Big Data', label: 'Big Data' },
// //     { value: 'Quantum Computing', label: 'Quantum Computing' },
// //     { value: 'Natural Language Processing', label: 'Natural Language Processing' },
// //     { value: 'Computer Vision', label: 'Computer Vision' },
// //     { value: 'Augmented Reality (AR)', label: 'Augmented Reality (AR)' },
// //     { value: 'Virtual Reality (VR)', label: 'Virtual Reality (VR)' },
// //     { value: 'Wireless Networks', label: 'Wireless Networks' },
// //     { value: 'Software Engineering', label: 'Software Engineering' },
// //     { value: 'Biotechnology', label: 'Biotechnology' },
// //   ];

// //   const handleDomainChange = (selectedOption) => {
// //     setSelectedDomain(selectedOption);
// //     setDomain(selectedOption.value);
// //   };

// //   const handleSearchChange = (event) => {
// //     setTitle(event.target.value);
// //   };

// //   const handleSearchSubmit = async (event) => {
// //     event.preventDefault();
// //     if (!title || !abstract || !requirements || !domain || !department) {
// //       setErrorMessage('Please fill out all the fields.');
// //       return;
// //     }

// //     try {
// //       const token = sessionStorage.getItem('Token');
// //       const response = await axios.post(`${backendURL}/searchForProject`, {
// //         query: title,
// //       }, {
// //         headers: { Authorization: `Bearer ${token}` },
// //       });

// //       const results = response.data;

// //       if (results.length > 0) {
// //         const top = results[0];
// //         setSimilarProject({
// //           title: top.project.ProjectTitle || 'No title available',
// //           abstract: top.project.abstract || 'No abstract available.',
// //           similarity: (top.score * 100).toFixed(2),
// //           isHighSimilarity: top.score > 0.8,
// //         });
// //         setShowWarning(true);
// //       } else {
// //         submitForm(token);
// //       }
// //     } catch (error) {
// //       setErrorMessage('An error occurred while checking similar projects.');
// //       console.error('Search error:', error);
// //     }
// //   };

// //   const submitForm = async (token) => {
// //     const data = {
// //       title,
// //       abstract,
// //       requirements,
// //       staff_name: user.name,
// //       domain,
// //       department,
// //       roll_id: user.rollId,
// //       project_type:'Project'
// //     };

// //     try {
// //       const response = await axios.post(`${backendURL}/add_project`, data, {
// //         headers: {
// //           'Content-Type': 'application/json',
// //           'Authorization': `Bearer ${token}`,
// //         },
// //         withCredentials: true,
// //       });

// //       if (response.data.message === 'Project added successfully!') {
// //         navigate('/EditDeletePublish');
// //       }
// //     } catch (error) {
// //       setErrorMessage('An error occurred while submitting the project. Please try again.');
// //       console.error('Form submission error:', error);
// //     }
// //   };

// //   const customStyles = {
// //     container: (provided) => ({ ...provided, width: '100%' }),
// //     control: (provided) => ({
// //       ...provided,
// //       backgroundColor: '#f0f0f0',
// //       border: '1px solid #ccc',
// //       borderRadius: '5px',
// //       boxShadow: 'none',
// //     }),
// //     menu: (provided) => ({ ...provided, borderRadius: '5px' }),
// //     option: (provided, state) => ({
// //       ...provided,
// //       backgroundColor: state.isFocused ? '#dcdcdc' : 'white',
// //       color: 'black',
// //     }),
// //     singleValue: (provided) => ({ ...provided, color: 'black' }),
// //   };

// //   useEffect(() => {
// //     if (!user) {
// //       navigate('/login');
// //     }
// //   }, [user, navigate]);

// //   return (
// //     <div className="upload-container-custom">
// //       <h2>Submit Your Data</h2>
// //       <form className="upload-form-horizontal" onSubmit={handleSearchSubmit}>
// //         <div className="form-item">
// //           <label htmlFor="title">Title</label>
// //           <input
// //             id="title"
// //             type="text"
// //             value={title}
// //             onChange={handleSearchChange}
// //             required
// //             aria-label="Enter the project title"
// //           />
// //         </div>

// //         <div className="form-item">
// //           <label htmlFor="abstract">Abstract</label>
// //           <textarea
// //             id="abstract"
// //             value={abstract}
// //             onChange={(e) => setAbstract(e.target.value)}
// //             required
// //           />
// //         </div>

// //         <div className="form-item">
// //           <label htmlFor="requirements">Requirements</label>
// //           <textarea
// //             id="requirements"
// //             value={requirements}
// //             onChange={(e) => setRequirements(e.target.value)}
// //             required
// //           />
// //         </div>

// //         <div className="form-item">
// //           <label>Faculty</label>
// //           <input type="text" value={user.name} disabled />
// //         </div>

// //         <div className="form-item">
// //           <label htmlFor="domain">Domain</label>
// //           <Select
// //             id="domain"
// //             options={projectDomains}
// //             styles={customStyles}
// //             value={selectedDomain}
// //             onChange={handleDomainChange}
// //             isSearchable
// //             placeholder="Search and select a domain..."
// //           />
// //         </div>

// //         <div className="form-item">
// //           <label htmlFor="department">Department</label>
// //           <select
// //             id="department"
// //             value={department}
// //             onChange={(e) => setDepartment(e.target.value)}
// //             required
// //           >
// //             <option value="">Select Department</option>
// //             <option value="CE">CE</option>
// //             <option value="EEE">EEE</option>
// //             <option value="ECE">ECE</option>
// //             <option value="ME">ME</option>
// //             <option value="CSE">CSE</option>
// //             <option value="CS-AIML">CS-AIML</option>
// //             <option value="CS-DS">CS-DS</option>
// //             <option value="CS-IOT">CS-IOT</option>
// //             <option value="CS-CyS">CS-CyS</option>
// //             <option value="AI & DS">AI & DS</option>
// //             <option value="CSBS">CSBS</option>
// //             <option value="EIE">EIE</option>
// //             <option value="IT">IT</option>
// //             <option value="AE">AE</option>
// //           </select>
// //         </div>

// //         <button type="submit" className="submit-btn">Submit</button>
// //       </form>

// //       {errorMessage && <div className="error-message">{errorMessage}</div>}

// //       {showWarning && similarProject && (
// //         <div
// //           className="warning-popup"
// //           style={{
// //             backgroundColor: similarProject.isHighSimilarity ? '#ffe5e5' : '#f0f0f0',
// //             border: `2px solid ${similarProject.isHighSimilarity ? 'red' : '#999'}`,
// //             padding: '15px',
// //             marginTop: '20px',
// //             borderRadius: '10px',
// //           }}
// //         >
// //           <h3 style={{ color: similarProject.isHighSimilarity ? 'red' : '#333' }}>
// //             {similarProject.isHighSimilarity
// //               ? '⚠️ High Similarity Project Found'
// //               : 'ℹ️ Similar Project Found'}
// //           </h3>
// //           <p><strong>Title:</strong> {similarProject.title}</p>
// //           <p><strong>Similarity:</strong> {similarProject.similarity}%</p>
// //           <p><strong>Abstract:</strong> {similarProject.abstract}</p>
// //           <p>Do you want to edit or continue submission?</p>
// //           <button
// //             className="submit-btn"
// //             onClick={() => {
// //               const token = sessionStorage.getItem('Token');
// //               submitForm(token);
// //               setShowWarning(false);
// //             }}
// //           >
// //             ✅ Submit Anyway
// //           </button>
// //           <button
// //             className="cancel-btn"
// //             onClick={() => setShowWarning(false)}
// //             style={{ marginLeft: '10px' }}
// //           >
// //             ✏️ Edit Project
// //           </button>
// //         </div>
// //       )}
// //     </div>
// //   );
// // }

// // export default FileUpload;


// import React, { useState, useEffect } from 'react';
// import './FileUpload1.css';
// import { useSelector } from 'react-redux';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import Select from 'react-select';

// function FileUpload() {
//   const backendURL = process.env.REACT_APP_backend_url;
//   const navigate = useNavigate();
//   const user = useSelector((state) => state.User.currentUser);

//   const [title, setTitle] = useState('');
//   const [abstract, setAbstract] = useState('');
//   const [requirements, setRequirements] = useState('');
//   const [domain, setDomain] = useState('');
//   const [department, setDepartment] = useState('');
//   const [selectedDomain, setSelectedDomain] = useState(null);
//   const [file, setFile] = useState(null);
//   const [showWarning, setShowWarning] = useState(false);
//   const [similarProject, setSimilarProject] = useState(null);
//   const [errorMessage, setErrorMessage] = useState('');

//   const projectDomains = [
//     { value: 'Artificial Intelligence', label: 'Artificial Intelligence' },
//     { value: 'Machine Learning', label: 'Machine Learning' },
//     { value: 'Data Science', label: 'Data Science' },
//     { value: 'Cybersecurity', label: 'Cybersecurity' },
//     { value: 'Cloud Computing', label: 'Cloud Computing' },
//     { value: 'Blockchain', label: 'Blockchain' },
//     { value: 'IoT (Internet of Things)', label: 'IoT (Internet of Things)' },
//     { value: 'Robotics', label: 'Robotics' },
//     { value: 'Embedded Systems', label: 'Embedded Systems' },
//     { value: 'VLSI', label: 'VLSI' },
//     { value: 'Renewable Energy', label: 'Renewable Energy' },
//     { value: 'Big Data', label: 'Big Data' },
//     { value: 'Quantum Computing', label: 'Quantum Computing' },
//     { value: 'Natural Language Processing', label: 'Natural Language Processing' },
//     { value: 'Computer Vision', label: 'Computer Vision' },
//     { value: 'Augmented Reality (AR)', label: 'Augmented Reality (AR)' },
//     { value: 'Virtual Reality (VR)', label: 'Virtual Reality (VR)' },
//     { value: 'Wireless Networks', label: 'Wireless Networks' },
//     { value: 'Software Engineering', label: 'Software Engineering' },
//     { value: 'Biotechnology', label: 'Biotechnology' },
//   ];

//   const handleDomainChange = (selectedOption) => {
//     setSelectedDomain(selectedOption);
//     setDomain(selectedOption.value);
//   };

//   const handleFileChange = (e) => {
//     setFile(e.target.files[0]);
//   };

//   const handleSearchChange = (event) => {
//     setTitle(event.target.value);
//   };

//   const handleSearchSubmit = async (event) => {
//     event.preventDefault();
//     if (!title || !abstract || !requirements || !domain || !department || !file) {
//       setErrorMessage('Please fill out all the fields and select a file.');
//       return;
//     }

//     try {
//       const token = sessionStorage.getItem('Token');
//       const response = await axios.post(`${backendURL}/searchForProject`, {
//         query: title,
//       }, {
//         headers: { Authorization: `Bearer ${token}` },
//       });

//       const results = response.data;

//       if (results.length > 0) {
//         const top = results[0];
//         setSimilarProject({
//           title: top.project.ProjectTitle || 'No title available',
//           abstract: top.project.abstract || 'No abstract available.',
//           similarity: (top.score * 100).toFixed(2),
//           isHighSimilarity: top.score > 0.8,
//         });
//         setShowWarning(true);
//       } else {
//         submitForm(token);
//       }
//     } catch (error) {
//       setErrorMessage('An error occurred while checking similar projects.');
//       console.error('Search error:', error);
//     }
//   };

//   const submitForm = async (token) => {
//     const formData = new FormData();
//     formData.append('title', title);
//     formData.append('abstract', abstract);
//     formData.append('requirements', requirements);
//     formData.append('staff_name', user.name);
//     formData.append('domain', domain);
//     formData.append('department', department);
//     formData.append('roll_id', user.rollId);
//     formData.append('project_type', 'Project');
//     formData.append('publish', 'TRUE'); // directly publish
//     formData.append('file', file);

//     try {
//       const response = await axios.post(`${backendURL}/add_project`, formData, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//           'Authorization': `Bearer ${token}`,
//         },
//         withCredentials: true,
//       });

//       if (response.data.message === 'Project added successfully!') {
//         navigate('/EditDeletePublish');
//       }
//     } catch (error) {
//       setErrorMessage('An error occurred while submitting the project. Please try again.');
//       console.error('Form submission error:', error);
//     }
//   };

//   const customStyles = {
//     container: (provided) => ({ ...provided, width: '100%' }),
//     control: (provided) => ({
//       ...provided,
//       backgroundColor: '#f0f0f0',
//       border: '1px solid #ccc',
//       borderRadius: '5px',
//       boxShadow: 'none',
//     }),
//     menu: (provided) => ({ ...provided, borderRadius: '5px' }),
//     option: (provided, state) => ({
//       ...provided,
//       backgroundColor: state.isFocused ? '#dcdcdc' : 'white',
//       color: 'black',
//     }),
//     singleValue: (provided) => ({ ...provided, color: 'black' }),
//   };

//   useEffect(() => {
//     if (!user) {
//       navigate('/login');
//     }
//   }, [user, navigate]);

//   return (
//     <div className="upload-container-custom">
//       <h2>Submit Your Project</h2>
//       <form className="upload-form-horizontal" onSubmit={handleSearchSubmit}>
//         <div className="form-item">
//           <label htmlFor="title">Title</label>
//           <input
//             id="title"
//             type="text"
//             value={title}
//             onChange={handleSearchChange}
//             required
//           />
//         </div>

//         <div className="form-item">
//           <label htmlFor="abstract">Abstract</label>
//           <textarea
//             id="abstract"
//             value={abstract}
//             onChange={(e) => setAbstract(e.target.value)}
//             required
//           />
//         </div>

//         <div className="form-item">
//           <label htmlFor="requirements">Requirements</label>
//           <textarea
//             id="requirements"
//             value={requirements}
//             onChange={(e) => setRequirements(e.target.value)}
//             required
//           />
//         </div>

//         <div className="form-item">
//           <label>Faculty</label>
//           <input type="text" value={user.name} disabled />
//         </div>

//         <div className="form-item">
//           <label htmlFor="domain">Domain</label>
//           <Select
//             id="domain"
//             options={projectDomains}
//             styles={customStyles}
//             value={selectedDomain}
//             onChange={handleDomainChange}
//             isSearchable
//             placeholder="Search and select a domain..."
//           />
//         </div>

//         <div className="form-item">
//           <label htmlFor="department">Department</label>
//           <select
//             id="department"
//             value={department}
//             onChange={(e) => setDepartment(e.target.value)}
//             required
//           >
//             <option value="">Select Department</option>
//             <option value="CE">CE</option>
//             <option value="EEE">EEE</option>
//             <option value="ECE">ECE</option>
//             <option value="ME">ME</option>
//             <option value="CSE">CSE</option>
//             <option value="CS-AIML">CS-AIML</option>
//             <option value="CS-DS">CS-DS</option>
//             <option value="CS-IOT">CS-IOT</option>
//             <option value="CS-CyS">CS-CyS</option>
//             <option value="AI & DS">AI & DS</option>
//             <option value="CSBS">CSBS</option>
//             <option value="EIE">EIE</option>
//             <option value="IT">IT</option>
//             <option value="AE">AE</option>
//           </select>
//         </div>

//         <div className="form-item">
//           <label htmlFor="file">Upload File</label>
//           <input
//             id="file"
//             type="file"
//             accept=".pdf,.doc,.docx,.ppt,.pptx"
//             onChange={handleFileChange}
//             required
//           />
//         </div>

//         <button type="submit" className="submit-btn">Submit & Publish</button>
//       </form>

//       {errorMessage && <div className="error-message">{errorMessage}</div>}

//       {showWarning && similarProject && (
//         <div
//           className="warning-popup"
//           style={{
//             backgroundColor: similarProject.isHighSimilarity ? '#ffe5e5' : '#f0f0f0',
//             border: `2px solid ${similarProject.isHighSimilarity ? 'red' : '#999'}`,
//             padding: '15px',
//             marginTop: '20px',
//             borderRadius: '10px',
//           }}
//         >
//           <h3 style={{ color: similarProject.isHighSimilarity ? 'red' : '#333' }}>
//             {similarProject.isHighSimilarity
//               ? '⚠️ High Similarity Project Found'
//               : 'ℹ️ Similar Project Found'}
//           </h3>
//           <p><strong>Title:</strong> {similarProject.title}</p>
//           <p><strong>Similarity:</strong> {similarProject.similarity}%</p>
//           <p><strong>Abstract:</strong> {similarProject.abstract}</p>
//           <p>Do you want to edit or continue submission?</p>
//           <button
//             className="submit-btn"
//             onClick={() => {
//               const token = sessionStorage.getItem('Token');
//               submitForm(token);
//               setShowWarning(false);
//             }}
//           >
//             ✅ Submit Anyway
//           </button>
//           <button
//             className="cancel-btn"
//             onClick={() => setShowWarning(false)}
//             style={{ marginLeft: '10px' }}
//           >
//             ✏️ Edit Project
//           </button>
//         </div>
//       )}
//     </div>
//   );
// }

// export default FileUpload;

import React, { useState, useEffect } from 'react';
import './FileUpload1.css';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Select from 'react-select';

function FileUpload() {
  const backendURL = process.env.REACT_APP_backend_url;
  const navigate = useNavigate();
  const user = useSelector((state) => state.User.currentUser);

  const [title, setTitle] = useState('');
  const [abstract, setAbstract] = useState('');
  const [requirements, setRequirements] = useState('');
  const [domain, setDomain] = useState('');
  const [department, setDepartment] = useState('');
  const [selectedDomain, setSelectedDomain] = useState(null);
  const [showWarning, setShowWarning] = useState(false);
  const [similarProject, setSimilarProject] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');

  const projectDomains = [
    { value: 'Artificial Intelligence', label: 'Artificial Intelligence' },
    { value: 'Machine Learning', label: 'Machine Learning' },
    { value: 'Data Science', label: 'Data Science' },
    { value: 'Cybersecurity', label: 'Cybersecurity' },
    { value: 'Cloud Computing', label: 'Cloud Computing' },
    { value: 'Blockchain', label: 'Blockchain' },
    { value: 'IoT (Internet of Things)', label: 'IoT (Internet of Things)' },
    { value: 'Robotics', label: 'Robotics' },
    { value: 'Embedded Systems', label: 'Embedded Systems' },
    { value: 'VLSI', label: 'VLSI' },
    { value: 'Renewable Energy', label: 'Renewable Energy' },
    { value: 'Big Data', label: 'Big Data' },
    { value: 'Quantum Computing', label: 'Quantum Computing' },
    { value: 'Natural Language Processing', label: 'Natural Language Processing' },
    { value: 'Computer Vision', label: 'Computer Vision' },
    { value: 'Augmented Reality (AR)', label: 'Augmented Reality (AR)' },
    { value: 'Virtual Reality (VR)', label: 'Virtual Reality (VR)' },
    { value: 'Wireless Networks', label: 'Wireless Networks' },
    { value: 'Software Engineering', label: 'Software Engineering' },
    { value: 'Biotechnology', label: 'Biotechnology' },
  ];

  const handleDomainChange = (selectedOption) => {
    setSelectedDomain(selectedOption);
    setDomain(selectedOption.value);
  };

  const handleSearchChange = (event) => {
    setTitle(event.target.value);
  };

  const handleSearchSubmit = async (event) => {
    event.preventDefault();
    if (!title || !abstract || !requirements || !domain || !department) {
      setErrorMessage('Please fill out all the fields.');
      return;
    }

    try {
      const token = sessionStorage.getItem('Token');
      const response = await axios.post(`${backendURL}/searchForProject`, {
        query: title,
      }, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const results = response.data;

      if (results.length > 0) {
        const top = results[0];
        setSimilarProject({
          title: top.project.ProjectTitle || 'No title available',
          abstract: top.project.abstract || 'No abstract available.',
          similarity: (top.score * 100).toFixed(2),
          isHighSimilarity: top.score > 0.8,
        });
        setShowWarning(true);
      } else {
        submitForm(token);
      }
    } catch (error) {
      setErrorMessage('An error occurred while checking similar projects.');
      console.error('Search error:', error);
    }
  };

  const submitForm = async (token) => {
    const data = {
      title,
      abstract,
      requirements,
      staff_name: user.name,
      domain,
      department,
      roll_id: user.rollId,
      project_type: 'Project',
      publish: 'TRUE', // directly publish
    };

    try {
      const response = await axios.post(`${backendURL}/add_project`, data, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        withCredentials: true,
      });

      if (response.data.message === 'Project added successfully!') {
        navigate('/EditDeletePublish');
      }
    } catch (error) {
      setErrorMessage('An error occurred while submitting the project. Please try again.');
      console.error('Form submission error:', error);
    }
  };

  const customStyles = {
    container: (provided) => ({ ...provided, width: '100%' }),
    control: (provided) => ({
      ...provided,
      backgroundColor: '#f0f0f0',
      border: '1px solid #ccc',
      borderRadius: '5px',
      boxShadow: 'none',
    }),
    menu: (provided) => ({ ...provided, borderRadius: '5px' }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? '#dcdcdc' : 'white',
      color: 'black',
    }),
    singleValue: (provided) => ({ ...provided, color: 'black' }),
  };

  useEffect(() => {
    if (!user) {
      navigate('/login');
    }
  }, [user, navigate]);

  return (
    <div className="upload-container-custom">
      <h2>Submit Your Project</h2>
      <form className="upload-form-horizontal" onSubmit={handleSearchSubmit}>
        <div className="form-item">
          <label htmlFor="title">Title</label>
          <input
            id="title"
            type="text"
            value={title}
            onChange={handleSearchChange}
            required
          />
        </div>

        <div className="form-item">
          <label htmlFor="abstract">Abstract</label>
          <textarea
            id="abstract"
            value={abstract}
            onChange={(e) => setAbstract(e.target.value)}
            required
          />
        </div>

        <div className="form-item">
          <label htmlFor="requirements">Requirements</label>
          <textarea
            id="requirements"
            value={requirements}
            onChange={(e) => setRequirements(e.target.value)}
            required
          />
        </div>

        <div className="form-item">
          <label>Faculty</label>
          <input type="text" value={user.name} disabled />
        </div>

        <div className="form-item">
          <label htmlFor="domain">Domain</label>
          <Select
            id="domain"
            options={projectDomains}
            styles={customStyles}
            value={selectedDomain}
            onChange={handleDomainChange}
            isSearchable
            placeholder="Search and select a domain..."
          />
        </div>

        <div className="form-item">
          <label htmlFor="department">Department</label>
          <select
            id="department"
            value={department}
            onChange={(e) => setDepartment(e.target.value)}
            required
          >
            <option value="">Select Department</option>
            <option value="CE">CE</option>
            <option value="EEE">EEE</option>
            <option value="ECE">ECE</option>
            <option value="ME">ME</option>
            <option value="CSE">CSE</option>
            <option value="CS-AIML">CS-AIML</option>
            <option value="CS-DS">CS-DS</option>
            <option value="CS-IOT">CS-IOT</option>
            <option value="CS-CyS">CS-CyS</option>
            <option value="AI & DS">AI & DS</option>
            <option value="CSBS">CSBS</option>
            <option value="EIE">EIE</option>
            <option value="IT">IT</option>
            <option value="AE">AE</option>
          </select>
        </div>

        <button type="submit" className="submit-btn">Submit & Publish</button>
      </form>

      {errorMessage && <div className="error-message">{errorMessage}</div>}

      {showWarning && similarProject && (
        <div
          className="warning-popup"
          style={{
            backgroundColor: similarProject.isHighSimilarity ? '#ffe5e5' : '#f0f0f0',
            border: `2px solid ${similarProject.isHighSimilarity ? 'red' : '#999'}`,
            padding: '15px',
            marginTop: '20px',
            borderRadius: '10px',
          }}
        >
          <h3 style={{ color: similarProject.isHighSimilarity ? 'red' : '#333' }}>
            {similarProject.isHighSimilarity
              ? '⚠️ High Similarity Project Found'
              : 'ℹ️ Similar Project Found'}
          </h3>
          <p><strong>Title:</strong> {similarProject.title}</p>
          <p><strong>Similarity:</strong> {similarProject.similarity}%</p>
          <p><strong>Abstract:</strong> {similarProject.abstract}</p>
          <p>Do you want to edit or continue submission?</p>
          <button
            className="submit-btn"
            onClick={() => {
              const token = sessionStorage.getItem('Token');
              submitForm(token);
              setShowWarning(false);
            }}
          >
            ✅ Submit Anyway
          </button>
          <button
            className="cancel-btn"
            onClick={() => setShowWarning(false)}
            style={{ marginLeft: '10px' }}
          >
            ✏️ Edit Project
          </button>
        </div>
      )}
    </div>
  );
}

export default FileUpload;
